"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dynamicListDataLoader = void 0;
const tslib_1 = require("tslib");
const index_1 = require("Views/Partials/Pages/index");
const FilterTypings_1 = require("Views/Partials/Components/Filters/FilterTypings");
const api_1 = require("../../../../src/api");
const FilterableList_1 = require("Views/Partials/Components/FilterableList/FilterableList");
const search_1 = require("src/search");
class DynamicListDataLoader {
    constructor() {
        this.NEWS_EVENTS_API_URL = '/umbraco/api/newseventsapi/allitems';
        this.loadData = (newParams) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            const defaultParams = this.getDefaultAPIParams();
            const params = Object.assign(Object.assign({}, defaultParams), newParams);
            const apiParams = this.buildApiParams(params);
            try {
                const response = yield (0, api_1.api)(this.NEWS_EVENTS_API_URL, apiParams);
                return this.processSuccessResult(response.data, params);
            }
            catch (error) {
                return this.processFailResult(error);
            }
        });
    }
    processSuccessResult(data, params) {
        const result = {};
        result.pageSize = data.pageSize;
        result.totalItems = data.totalItems;
        result.pageCount = data.pageCount;
        result.pageNumber = data.pageNumber && data.pageNumber - 1;
        result.sortBy = params.sort || data.sortBy;
        result.items = this.convertDocumentsToTiles(data.items);
        result.status = this.applyStatusOnResult(data.items);
        return result;
    }
    buildApiParams(newParams) {
        const defaultParams = this.getDefaultAPIParams();
        const result = Object.assign(Object.assign({}, defaultParams), newParams);
        return result;
    }
    getDefaultAPIParams() {
        const params = {
            publishedContent: index_1.PageContext.publishedContent,
            id: index_1.PageContext.pageId,
            sort: index_1.PageContext.sortBy,
            pageSize: 10,
            page: 1,
        };
        return params;
    }
    applyStatusOnResult(items) {
        const itemsNotFound = !items || items.length < 1;
        if (itemsNotFound) {
            return {
                statusCode: FilterableList_1.ListStatusCode.zeroResults,
                message: index_1.PageContext.filterableDictionary.zeroResultsMessage,
            };
        }
        return { statusCode: FilterableList_1.ListStatusCode.success };
    }
    convertDocumentsToTiles(items) {
        let result = [];
        if (items && items.length > 0) {
            result = items.map(item => this.createTileListItem(item));
        }
        return result;
    }
    createTileListItem(item) {
        const result = {};
        result.id = item.path;
        result.title = item.title;
        result.description = item.description;
        result.image = item.image;
        result.link = { url: item.path };
        result.imageAltText = item.imageAltText;
        result.location = (0, search_1.transformLocationParam)(item.location);
        if (index_1.PageContext.type === FilterTypings_1.FilterableListTypeEnum.News) {
            result.formattedStartDate = item.date;
        }
        if (index_1.PageContext.type === FilterTypings_1.FilterableListTypeEnum.Events) {
            result.formattedStartDate = item.date;
            result.formattedEndDate = item.endDate;
        }
        return result;
    }
    processFailResult(error) {
        return {
            pageSize: 0,
            items: [],
            totalItems: 0,
            hasNextPage: false,
            hasPreviousPage: false,
            sortBy: index_1.PageContext.sortBy,
            status: {
                statusCode: FilterableList_1.ListStatusCode.communicationError,
                message: index_1.PageContext.dictionary.communicationErrorMessage || error,
            },
        };
    }
}
exports.dynamicListDataLoader = new DynamicListDataLoader();
